// removed by extract-text-webpack-plugin
module.exports = {"BreakpointToMedium":"(max-width: 639px)","boxPriceList":"G6ab76d Gf02906"};